import { createContext } from 'react';
export const AppUiContext = createContext(null);
